'use client';

import { ToastContainer } from '@epos/ui/components';

import QueryProvider from '@/components/query-provider';
import StoreProvider from '@/components/store-provider';
import ThemeRegistry from '@/components/theme-config/theme-registry';

const Providers: React.FC<ComponentWithChildren> = ({ children }) => {
  return (
    <ThemeRegistry>
      <QueryProvider>
        <StoreProvider>
          {children}
          <ToastContainer autoClose={5000} />
        </StoreProvider>
      </QueryProvider>
    </ThemeRegistry>
  );
};

export default Providers;
